

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrder} from "@/model/Order/orderInterfaces";

  @Component({
    name: 'OOProfessionalServiceDetails',
    components: {
    }
  })
  export default class OOProfessionalServiceDetails extends Vue {

    @Prop()
    protected order!: IOrder;


    protected isEditing: boolean = false;
    protected editDate: string = '';
    protected editTime: string = '';
    protected originalDate: string = '';
    protected originalTime: string = '';

    protected get dateRules(): any[] {
      return [
        (v: string) => !!v || this.$t('orders.order.professional_service.service_details_section.fields.date_future'),
        (v: string) => {
          if (!v) return this.$t('orders.order.professional_service.service_details_section.fields.date_required');
          const today = new Date();

          today.setHours(today.getHours() + 24);
          today.setHours(0, 0, 0, 0);
          const selectedDate = new Date(v);
          return selectedDate >= today || this.$t('orders.order.professional_service.service_details_section.fields.date_future');
        },

         (v: string) => {
          if (!v) return this.$t('orders.order.professional_service.service_details_section.fields.date_required');
          const today = new Date();

          today.setHours(today.getHours() + 24);
          today.setHours(0, 0, 0, 0);
          const selectedDate = new Date(v);

          const maxDate = new Date();
          maxDate.setMonth(maxDate.getMonth() + 2);
          maxDate.setHours(0, 0, 0, 0);
          return selectedDate >= today && selectedDate <= maxDate || this.$t('orders.order.professional_service.service_details_section.fields.date_future_maximum');
        }
      ];
    }

    protected get timeRules(): any[] {
      return [
        (v: string) => !!v || this.$t('orders.order.professional_service.service_details_section.fields.time_required'),
        (v: string) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || this.$t('orders.order.professional_service.service_details_section.fields.time_format')
      ];
    }

    protected get isValidEdit(): boolean {
      if (!this.editDate || !this.editTime) return false;
      
      const today = new Date();
      today.setHours(today.getHours() + 24);
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(this.editDate);

      // maximo 2 meses en el futuro
      const maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + 2);
      maxDate.setHours(0, 0, 0, 0);

      return selectedDate >= today && selectedDate <= maxDate && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(this.editTime);
    }

    protected get startingDate(): string {
      if (this.order.professional_service_data) {
        const serviceData = this.order.professional_service_data as any;
        if (serviceData.details && serviceData.details.start_at) {
          const dateTime = serviceData.details.start_at;
          const datePart = dateTime.split(/[\sT]/)[0];
          return datePart;
        }
      }
      return '>DD-MM-YYYY';
    }

    protected get minDate(): string {
      const today = new Date();
      return today.toISOString().split('T')[0];
    }

    protected get maxDate(): string {
      const today = new Date();
      today.setMonth(today.getMonth() + 2); // Agrega 2 meses
      return today.toISOString().split('T')[0];
    }

    protected get startingHour(): string {
      if (this.order.professional_service_data) {
        const serviceData = this.order.professional_service_data as any;
        if (serviceData.details && serviceData.details.start_at) {
          const dateTime = serviceData.details.start_at;
          const timePart = dateTime.split(/[\sT]/)[1];
          return timePart ? timePart.substring(0, 5) : '> Hour';
        }
      }
      return '> Hour';
    }

    protected get canEdit(): boolean {
        const serviceData = this.order.professional_service_data as any;
        const madridTime = new Date().toLocaleString("en-US", {timeZone: "Europe/Madrid"});
        const now = new Date(madridTime);

        const startAt = new Date(serviceData.details.start_at);
        
        const diffInMs = startAt.getTime() - now.getTime();
        
        const diffInHours = diffInMs / (1000 * 60 * 60);
        
        if(serviceData.details && diffInHours < 24) {
            return false;
        }
       return (serviceData.status !== 'status_order_completed');
    }

    protected get cancellationInfo(): boolean {
      const serviceData = this.order as IOrder;
      return (serviceData.status === 'status_order_client_cancelled');
    }

    protected get cancellationDate(): string {
        const serviceData = this.order as IOrder;
        const cancelledAt = serviceData.cancelled_at;
        if (cancelledAt) {
          const datePart = cancelledAt.split(/[\sT]/)[0];
          return datePart;
        }
      
      return '--/--/----';
    }

    protected get cancellationTime(): string {
        const serviceData = this.order as IOrder;
        const cancelledAt = serviceData.cancelled_at;
        if (cancelledAt) {
          const timePart = cancelledAt.split(/[\sT]/)[1];
          return timePart ? timePart.substring(0, 5) : '--:--';
        }
      
      return '--:--';
    }

    protected get cancellationReason(): string {
        const serviceData = this.order as IOrder;
        return String(this.$t(`orders.order.professional_service.service_details_section.fields.cancellation_reasons.${serviceData.cancellation_reason}`)) || '';
    }

    protected get cancellationText(): string {
        const serviceData = this.order as IOrder;
        return serviceData.cancellation_reason_text || '';
    }

    protected get refundPercentage(): number {
        const serviceData = this.order as IOrder;
        return serviceData.refund_percentage || 0;
    }

    protected get refundAmount(): string {
        const serviceData = this.order as IOrder;
        const amount = serviceData.refund_amount || 0;
        if (amount) {
          return `€${amount}`;
        }
      
      return '€0.00';
    }

    protected toggleEdit(): void {
      if (this.isEditing) {
        this.saveChanges();
      } else {
        this.startEdit();
      }
    }

    protected startEdit(): void {
      this.isEditing = true;
      this.editDate = this.getCurrentDateValue();
      this.editTime = this.getCurrentTimeValue();
      this.originalDate = this.editDate;
      this.originalTime = this.editTime;
    }

    protected cancelEdit(): void {
      this.isEditing = false;
      this.editDate = this.originalDate;
      this.editTime = this.originalTime;
    }

    protected async saveChanges(): Promise<void> {
      if (!this.isValidEdit) {
        return;
      }
      
      await this.updateServiceDate({
        orderId: this.order.id,
        start_at: `${this.editDate}T${this.editTime}:00`
      });
      
      this.isEditing = false;
    }

    private async updateServiceDate(payload: any): Promise<void> {
      this.$store.dispatch('orderModule/updateOrderProfessionalServiceDateTime', {orderId: payload.orderId, newDateTime: payload.start_at});
    }

    private getCurrentDateValue(): string {
      if (this.order.professional_service_data) {
        const serviceData = this.order.professional_service_data as any;
        if (serviceData.details && serviceData.details.start_at) {
          const dateTime = serviceData.details.start_at;
          return dateTime.split(/[\sT]/)[0];
        }
      }
      return new Date().toISOString().split('T')[0];
    }

    private getCurrentTimeValue(): string {
      if (this.order.professional_service_data) {
        const serviceData = this.order.professional_service_data as any;
        if (serviceData.details && serviceData.details.start_at) {
          const dateTime = serviceData.details.start_at;
          const timePart = dateTime.split(/[\sT]/)[1];
          return timePart ? timePart.substring(0, 5) : '09:00';
        }
      }
      return '09:00';
    }

    private getOriginalDateTime(): string {
      if (this.order.professional_service_data) {
        const serviceData = this.order.professional_service_data as any;
        if (serviceData.details && serviceData.details.start_at) {
          return serviceData.details.start_at;
        }
      }
      return '';
    }

    private mapDayAbbreviation(abbreviation: string): string {
      const dayMap: { [key: string]: string } = {
        'mon': 'monday',
        'tue': 'tuesday',
        'wed': 'wednesday',
        'thu': 'thursday',
        'fri': 'friday',
        'sat': 'saturday',
        'sun': 'sunday'
      };
      return dayMap[abbreviation.toLowerCase()] || abbreviation;
    }

  }

